import { Tooltip as AntdTooltip, TooltipProps } from "antd";

interface IProps extends Omit<TooltipProps, "disabled"> {
  disabled?: boolean;
}

export function Tooltip(props: IProps) {
  const { disabled, children, ...rest } = props;
  if (disabled) {
    return children;
  }
  return <AntdTooltip {...rest}>{children}</AntdTooltip>;
}
